export function start(file, ...args) {
  if (process.env.NODE_ENV === "development") {
    console.log(`[${file}]:`, "START", ...args);
  }
}

export function end(file, ...args) {
  if (process.env.NODE_ENV === "development") {
    console.log(`[${file}]:`, "END", ...args);
  }
}

export function log(file, ...args) {
  if (process.env.NODE_ENV === "development") {
    console.log(`[${file}]:`, ...args);
  }
}

export function success(file, ...args) {
  if (process.env.NODE_ENV === "development") {
    console.log(`[${file}]:`, "SUCCESS", ...args);
  }
}

export function error(file, err, ...args) {
  if (process.env.NODE_ENV === "development") {
    console.log(`[${file}]:`, "ERROR", err, ...args);
  }
}
